
export type ChallengeStatusTone = "success" | "info" | "neutral" | "warning";

export interface ChallengeStatusPresentation {
  label: string;
  tone: ChallengeStatusTone;
}

export const CHALLENGE_STATUSES = [
  { value: "scheduled", label: "زمان‌بندی‌شده", tone: "info" },
  { value: "active", label: "فعال", tone: "success" },
  { value: "closed", label: "بسته‌شده", tone: "neutral" },
] as const satisfies readonly ({ value: string } & ChallengeStatusPresentation)[];

const STATUS_PRESENTATION: Record<string, ChallengeStatusPresentation> =
  Object.fromEntries(
    CHALLENGE_STATUSES.map(({ value, label, tone }) => [value, { label, tone }]),
  );

const TONE_CLASSES: Record<ChallengeStatusTone, string> = {
  success: "bg-successVar-light text-successVar-dark",
  info: "bg-infoVar-light text-infoVar-dark",
  neutral: "bg-gray-100 text-gray-600",
  warning: "bg-warningVar-light text-warningVar-dark",
};

export const getChallengeStatusPresentation = (status: string | null | undefined): ChallengeStatusPresentation => {
  if (!status) return { label: "-", tone: "neutral" };

  const normalized = status.trim().toLowerCase();

  return STATUS_PRESENTATION[normalized] ?? { label: "نامشخص", tone: "neutral" };
};

export const matchesChallengeStatusFilter = (
  status: string | null | undefined,
  filterValue: string,
): boolean => {
  if (!filterValue) return true;
  if (!status) return false;

  return status.trim().toLowerCase() === filterValue;
};

export const getChallengeStatusToneClasses = (tone: ChallengeStatusTone): string => TONE_CLASSES[tone];

export const CHALLENGE_WEEK_DAY_OPTIONS = [
  { value: "0", label: "شنبه" },
  { value: "1", label: "یکشنبه" },
  { value: "2", label: "دوشنبه" },
  { value: "3", label: "سه‌شنبه" },
  { value: "4", label: "چهارشنبه" },
  { value: "5", label: "پنجشنبه" },
  { value: "6", label: "جمعه" },
];

export const CHALLENGE_MONTH_OPTIONS = [
  { value: "1", label: "فروردین" },
  { value: "2", label: "اردیبهشت" },
  { value: "3", label: "خرداد" },
  { value: "4", label: "تیر" },
  { value: "5", label: "مرداد" },
  { value: "6", label: "شهریور" },
  { value: "7", label: "مهر" },
  { value: "8", label: "آبان" },
  { value: "9", label: "آذر" },
  { value: "10", label: "دی" },
  { value: "11", label: "بهمن" },
  { value: "12", label: "اسفند" },
];

export const CHALLENGE_STATUS_FILTER_OPTIONS = CHALLENGE_STATUSES.map(
  ({ value, label }) => ({ value, label }),
);
